var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBriefcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 8.66667H9.66732V8H4.33398V8.66667H3.00065V8H0.333984V11.3333H13.6673V8H11.0007V8.66667Z",
    fill: "#838AA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.334 3.33464H10.334V2.0013C10.334 1.26797 9.73398 0.667969 9.00065 0.667969H5.00065C4.26732 0.667969 3.66732 1.26797 3.66732 2.0013V3.33464H1.66732C0.933984 3.33464 0.333984 3.93464 0.333984 4.66797V7.33464H3.00065V6.0013H4.33398V7.33464H9.66732V6.0013H11.0007V7.33464H13.6673V4.66797C13.6673 3.93464 13.0673 3.33464 12.334 3.33464ZM9.00065 3.33464H5.00065V2.0013H9.00065V3.33464Z",
    fill: "#838AA1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBriefcase);
export default __webpack_public_path__ + "static/media/icon-briefcase.26e0b4a83389b4c70ae2554db77ae216.svg";
export { ForwardRef as ReactComponent };